import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@ww/react-ui-components';
import StoresContext from 'stores';
import GqlClientProvider from 'utils/gql';
import config from 'config';
import { FronteggProviderWrapper } from 'components/FronteggProviderWrapper/FronteggProviderWrapper';
import { ServerAuthHandoff } from 'components/ServerAuthHandoff/ServerAuthHandoff';
import { FronteggAwareLogin } from 'components/FronteggAwareLogin/FronteggAwareLogin';

function getFavicon(): HTMLLinkElement | null {
  const favicon = document.getElementById('favicon');

  return favicon instanceof HTMLLinkElement ? favicon : null;
}

function App(): JSX.Element {
  useEffect(() => {
    const favicon = getFavicon();
    if (favicon) favicon.href = config.favicon;
  });

  return (
    <Router>
      <div className="App">
        <ThemeProvider>
          <FronteggProviderWrapper>
            <StoresContext>
              <GqlClientProvider>
                <ServerAuthHandoff>
                  <FronteggAwareLogin />
                </ServerAuthHandoff>
              </GqlClientProvider>
            </StoresContext>
          </FronteggProviderWrapper>
        </ThemeProvider>
      </div>
    </Router>
  );
}

export default App;
